export function enumToArray(object: any) {
  return Object.values(object).filter(
    (value) => typeof value === 'string',
  ) as string[];
}
